/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { CloudResource } from '@modules/billing-api/v1/types'

export const FIXED_RECIPIENTS = ['Organization owner', 'Billing admin']

export const FIXED_SCOPE = ['Organization']

export const CLOUD_RESOURCE_NAME: Record<CloudResource['type'], string> = {
  cloud_connect: 'Cloud Connect',
  deployment: 'Deployment',
  elasticsearch: 'Elasticsearch',
  observability: 'Observability',
  security: 'Security',
}

export const DEFAULT_CLOUD_RESOURCE_NAME = 'Others'
